import { AdFormatTypeEnum, OldAdFormatTypeEnum } from "../enums";

export const mapAdFormat: any = {
    [OldAdFormatTypeEnum.SingleAd]: AdFormatTypeEnum.SINGLE,
    [OldAdFormatTypeEnum.CarouselAd]: AdFormatTypeEnum.CAROUSEL,
    [OldAdFormatTypeEnum.Existing]: AdFormatTypeEnum.EXISTING,
    [OldAdFormatTypeEnum.Collection]: AdFormatTypeEnum.COLLECTION
}